import axios from 'axios';
import { handleError } from '../utils/error';
const API_URL = process.env.AUTH_API_URL;
/*
  CREATE
*/
export const postUser = async ({ token, email }) => {
    try {
        const response = await axios.post(`${API_URL}/user`, { email }, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response;
    }
    catch (error) {
        handleError('postUser', error);
        return error.response;
    }
};
export const postUserSignUp = async ({ email, signUpList }) => {
    try {
        const response = await axios.post(`${API_URL}/sign-up`, {
            email,
            signUpList
        });
        return response;
    }
    catch (error) {
        handleError('postUserSignUp', error);
        return error.response;
    }
};
export const postMapIds = async ({ serviceToken, type, listOfIds }) => {
    try {
        const response = await axios.post(`${API_URL}/map-ids`, { type, listOfIds }, {
            headers: {
                Authorization: `Bearer ${serviceToken}`
            }
        });
        return response;
    }
    catch (error) {
        handleError('postUser', error);
        return error.response;
    }
};
/*
  READ
*/
export const persist = async ({ token, itemNumber = null }) => {
    try {
        const response = await axios.post(`${API_URL}/persist`, {
            itemNumber
        }, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response;
    }
    catch (error) {
        handleError('persist', error);
        return error.response;
    }
};
export const getToken = async ({ authCode }) => {
    try {
        const response = await axios.post(`${API_URL}/get-token`, {
            authCode
        });
        return response;
    }
    catch (error) {
        handleError('getToken', error);
        return error.response;
    }
};
export const getUser = async ({ serviceToken, id, email }) => {
    const queryString = id ? `?id=${id}` : email ? `?email=${email}` : null;
    try {
        if (queryString) {
            const response = await axios.get(`${API_URL}/user${queryString}`, {
                headers: {
                    Authorization: `Bearer ${serviceToken}`
                }
            });
            return response;
        }
        return null;
    }
    catch (error) {
        handleError('getUser', error);
        return error.response;
    }
};
export const getCommandBotUser = async ({ serviceToken }) => {
    try {
        const response = await axios.get(`${API_URL}/bot-user`, {
            headers: { Authorization: `Bearer ${serviceToken}` }
        });
        return response;
    }
    catch (error) {
        handleError('getCommandBotUser', error);
        return error.response;
    }
};
export const getTracker = async ({ token, itemNumber, startDate, endDate }) => {
    try {
        const response = await axios.get(`${API_URL}/tracker/${itemNumber}/${startDate}/${endDate}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response;
    }
    catch (error) {
        handleError('getTracker', error);
        return error.response;
    }
};
export const getAddress = async ({ token }) => {
    try {
        const response = await axios.get(`${API_URL}/address`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response;
    }
    catch (error) {
        handleError('getAddress', error);
        return error.response;
    }
};
export const getSubscriptions = async ({ token, email }) => {
    try {
        const response = await axios.get(`${API_URL}/subscriptions/${email}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response;
    }
    catch (error) {
        handleError('getSubscriptions', error);
        return error.response;
    }
};
export const getTunnel = async ({ key, data }) => {
    try {
        const response = await axios.post(`${API_URL}/tunnel/`, { ...data }, {
            headers: {
                Authorization: `Bearer ${key}`
            }
        });
        return response;
    }
    catch (error) {
        handleError('getTunnel', error);
        return error.response;
    }
};
/*
  UPDATE
*/
export const putUser = async ({ token, user }) => {
    try {
        const response = await axios.put(`${API_URL}/users/${user._id}`, user, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response;
    }
    catch (error) {
        handleError('putUser', error);
        return error.response;
    }
};
export const putUserIncrement = async ({ serviceToken, id }) => {
    try {
        const response = await axios.put(`${API_URL}/increment`, {
            id
        }, {
            headers: {
                Authorization: `Bearer ${serviceToken}`
            }
        });
        return response;
    }
    catch (error) {
        handleError('putUserIncrement', error);
        return error.response;
    }
};
export const putUserSubscriptions = async ({ serviceToken, email }) => {
    try {
        const response = await axios.put(`${API_URL}/subs/${email}`, {}, {
            headers: {
                Authorization: `Bearer ${serviceToken}`
            }
        });
        return response;
    }
    catch (error) {
        handleError('putUserSubscriptions', error);
        return error.response;
    }
};
export const putAddress = async ({ token, data }) => {
    try {
        const response = await axios.put(`${API_URL}/address`, {
            data
        }, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response;
    }
    catch (error) {
        handleError('putAddress', error);
        return error.response;
    }
};
export const putCreditCard = async ({ token, data }) => {
    try {
        const response = await axios.put(`${API_URL}/credit-card`, {
            ...data
        }, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response;
    }
    catch (error) {
        handleError('putCreditCard', error);
        return error.response;
    }
};
export const putSubscriptionEmail = async ({ token, subRef, existingEmail, newEmail }) => {
    try {
        const response = await axios.put(`${API_URL}/subscription-email`, {
            subRef,
            existingEmail,
            newEmail
        }, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response;
    }
    catch (error) {
        handleError('putSubscriptionEmail', error);
        return error.response;
    }
};
/*
  DELETE
*/
/*
  UNSORTED
*/
/*
  PASSWORDS
*/
export const forgotPassword = async ({ data }) => {
    try {
        const response = await axios.post(`${API_URL}/forgot-password`, { ...data });
        return response;
    }
    catch (error) {
        handleError('forgotPassword', error);
        return error.response;
    }
};
export const resetPassword = async ({ data }) => {
    try {
        const response = await axios.post(`${API_URL}/reset-password`, { ...data });
        return response;
    }
    catch (error) {
        handleError('resetPassword', error);
        return error.response;
    }
};
export const updatePassword = async ({ token, data }) => {
    try {
        const response = await axios.post(`${API_URL}/update-password`, { ...data }, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response;
    }
    catch (error) {
        handleError('updatePassword', error);
        return error.response;
    }
};
//# sourceMappingURL=Users.js.map